import React, { useState } from "react";
import { Helmet } from "react-helmet";
import "./home.css"; // Place your styles here
import Header from "../components/common/Header";

const IndexPage = () => {
  const [currentBox, setCurrentBox] = useState(0);
  const [letters, setLetters] = useState(Array(5).fill(""));

  const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (currentBox >= 5) return;
  
    if (e.key.match(/^[a-zA-Z]$/)) {
      const newLetters = [...letters];
      newLetters[currentBox] = e.key.toUpperCase();
      setLetters(newLetters);
      setCurrentBox(currentBox + 1);
    }
  };

  return (
    <div tabIndex={0} onKeyDown={handleKeyDown} className="index-page">
        <Helmet>
            {/* 基础信息 */}
            <title>Games Like Wordle - Discover Daily Word Puzzle Games</title>
            <meta
            name="description"
            content="Explore our curated collection of Wordle-inspired word games. Challenge yourself with new daily puzzles, themes, and difficulty levels."
            />
            <meta
            name="keywords"
            content="Wordle, word games, Wordle alternatives, daily puzzles, word puzzle games, Wordle-like games"
            />
            <meta name="author" content="GamesLikeWordle" />

            {/* Social Media / Open Graph */}
            <meta property="og:title" content="Games Like Wordle - Discover Daily Word Puzzle Games" />
            <meta
            property="og:description"
            content="Discover new word games inspired by Wordle. Join our community of puzzle enthusiasts and take on daily challenges!"
            />
            <meta property="og:url" content="https://www.gameslikewordle.com" />
            <meta property="og:type" content="website" />
            <meta property="og:image" content="https://www.gameslikewordle.com/og-image.jpg" />
            
            {/* Twitter */}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content="Games Like Wordle - Discover Daily Word Puzzle Games" />
            <meta
            name="twitter:description"
            content="Explore our curated collection of Wordle-inspired word games. Take on daily challenges and connect with a vibrant community of puzzle enthusiasts."
            />
            <meta name="twitter:image" content="https://www.gameslikewordle.com/twitter-image.jpg" />
            <meta name="twitter:site" content="@GamesLikeWordle" />

            {/* Canonical URL */}
            <link rel="canonical" href="https://www.gameslikewordle.com" />
        </Helmet>

      <Header></Header>

      <section className="hero">
        <div className="container">
          <h1>Discover New Word Games<br /><span>Like Wordle Daily</span></h1>
          <p>Explore our curated collection of word puzzle games similar to Wordle. Challenge yourself with new variations, themes, and difficulty levels.</p>
          <a href="/dictadle" className="btn btn-primary">Start Playing →</a>
        </div>
      </section>

      <section className="features">
        <div className="container">
          <div className="features-grid">
            <div className="feature-card">
              <h3>Multiple Games</h3>
              <p>Discover new word games updated daily with varying difficulty levels and themes.</p>
            </div>
            <div className="feature-card">
              <h3>Active Community</h3>
              <p>Join thousands of players sharing strategies and competing on global leaderboards.</p>
            </div>
            <div className="feature-card">
              <h3>Daily Challenges</h3>
              <p>Complete special daily puzzles and earn achievements as you play.</p>
            </div>
          </div>
        </div>
      </section>


      <section className="cta">
        <div className="container">
          <h2>Ready to start playing?</h2>
          <p>Join our community of word game enthusiasts today.</p>
          {/* <a href="/signup" className="btn btn-white">Sign Up Free →</a> */}
        </div>
      </section>
    </div>
  );
};

export default IndexPage;